<template>
	<div class="sub-window">
		<slot></slot>
	</div>
</template>
<script>
  import {onMessage} from '../../../utils/event-bus';
  import Constants from '../../../utils/constants';
  import Global from '../../../utils/global';
  export default {
    name: 'KiafSubWindow',
    beforeCreate() {
      let windows = Global.getWindows();
      windows.forEach(win => {
        if (!window[win.windowId] && window.opener && window.opener[win.windowId]) { //非常重要，用来获取弹出的所有窗口，在联动关闭窗口时会用到
          window[win.windowId] = window.opener[win.windowId];
        }
      });
      console.log('sub window>>>', window);
      console.log('sub window.opener>>>', window.opener);
      onMessage(Constants.EVENT_BUS_CODE_CLOSE_ALL_WIN);
    },
	created() {
      Global.setSubWindow();
	}
  };
</script>
<style scoped>
	.sub-window{
		overflow: auto;
	}
</style>
